module.exports = __webpack_public_path__ + "cf8005f80078969f2c86c24ef32e58be.pdf";